module.exports = __webpack_public_path__ + "img/J12326.da67e74d.png";